import { useEffect, useRef } from 'react';

import { toast } from '@backyard-ui/core';

import { type Response as CartShipmentsResponse } from '@/infra/services/checkout/cart/get-cart-shipments';

interface UseAutoSelectDefaultModalityProps {
  shipmentsData: CartShipmentsResponse | undefined;
  isLoading: boolean;
  getPhoneNumber: () => string;
  changeShipmentModality: (params: {
    cartId: string;
    phone?: string;
    delivery: Array<{
      shipmentId: string;
      type: string;
    }>;
  }) => void;
}

export function useAutoSelectDefaultModality({
  shipmentsData,
  isLoading,
  getPhoneNumber,
  changeShipmentModality,
}: UseAutoSelectDefaultModalityProps) {
  const hasAutoSelectedRef = useRef<string | null>(null);

  useEffect(() => {
    const cartId = shipmentsData?.data?.id;
    if (!cartId || isLoading) return;
    if (hasAutoSelectedRef.current === cartId) return;

    const shipments = shipmentsData?.data?.shippings?.[0]?.shipments || [];
    if (shipments.length === 0) return;

    const phoneNumber = getPhoneNumber();

    const defaultDeliveries = shipments
      .filter((s) => s.modalities?.[0] && s.shipment_id)
      .map((s) => ({
        shipmentId: s.shipment_id.toString(),
        type: s.modalities[0].type,
      }));

    if (defaultDeliveries.length === 0 && shipments.length > 0) {
      toast({
        description:
          'Não foi possível processar a modalidade de entrega. Por favor, tente novamente.',
        appearance: 'critical',
      });
      hasAutoSelectedRef.current = cartId;
      return;
    }

    if (defaultDeliveries.length > 0) {
      hasAutoSelectedRef.current = cartId;
      changeShipmentModality({
        cartId,
        phone: phoneNumber || undefined,
        delivery: defaultDeliveries,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shipmentsData?.data?.id]);
}
